import React from 'react';

const ContentfulBlockWellnessCoveragePlans = (plans) => {
     return(
          <> </>
     )
};

export { ContentfulBlockWellnessCoveragePlans }